import { useCallback, useEffect, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { CategoryData, FilterCheckbox, GetProductFilterDataFromString, ProductFilterData } from "vagaro-website-rendering/src/components/BusinessControls/RenderBusinessProducts";
import { getProductCategories } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { DownCaret, LeftCaret, RightCaret } from "../Icons/Carets";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import SelectDropdown from "../SelectDropdown";



const limitOptions = [
    {label:"None",value:"100"},
    {label:"1",value:"1"},
    {label:"2",value:"2"},
    {label:"3",value:"3"},
    {label:"4",value:"4"},
    {label:"5",value:"5"},
    {label:"6",value:"6"},
    {label:"7",value:"7"},
    {label:"8",value:"8"},
    {label:"9",value:"9"},
    {label:"10",value:"10"},
    {label:"11",value:"11"},
    {label:"12",value:"12"},
]




export default function ProductFilterField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){



    const bgStyle = {
        background:"white",
        borderRadius:"4px",
        boxShadow:"rgba(0, 0, 0, 0.02) 0px 0px 10px 10px",
        marginTop:"8px",
        padding:"4px",
    }



    let val = getNodeComponentAttributeValue(layoutObject,definition.attKey,"");


    let data:ProductFilterData = GetProductFilterDataFromString(val);

    //untested removal. disabling linter until validated @TODO
// eslint-disable-next-line
    const [isLoading,setIsLoading] = useState(true);




    const [search,setSearch] = useState(data.search);
    const [selectedCat,setCurrentCat] = useState(data.cat);
    const [limit,setLimit] = useState(data.limit);
    const [brands,setBrands] = useState(data.brands.split(",").filter((b)=>{return b.length>0}));

    const [availableBrands,setAvailableBrands] = useState<{ name: string, id: string }[]>([]);
    const [availableCats,setAvailableCats] = useState<CategoryData[]>([]);


    useEffect(()=>{

        getProductCategories(siteData.userContext,(data:any)=>{

            if(data.categories){

                const inCats:CategoryData[] = data.categories;
                setAvailableCats(inCats);

            }
            if(data.brands)
                setAvailableBrands(data.brands);

            setIsLoading(false);

        },(err:any)=>{

            setIsLoading(false);

        });

// eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{

        let newData = encodeURIComponent( JSON.stringify({search,cat:selectedCat,brands:brands.join(","),limit}));

        updateFunc(definition.attKey,newData,definition.targetType);
        (layoutObject as LayoutNode).data = null;
        let n = layoutObject as LayoutNode;
        n.forceUpdate&&n.forceUpdate();
    
        saveFunc();
// eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedCat,search,limit,brands])

    

    const MapCategories =useCallback(()=> {

        let current  = selectedCat;
        let currentCat = availableCats.find((c)=>{return c.id === selectedCat});

        let parentCatName  = "";
        let parentId = "";
        if(currentCat &&currentCat.parentCategoryId&&currentCat.parentCategoryId.length>0){
             parentId = currentCat.parentCategoryId;
            let parentCat = availableCats.find((c)=>{return c.id === parentId});
            parentCatName = (parentCat)?parentCat.name:"All Products";
        }

        if(currentCat && currentCat.parentCategoryId.length<=0){
            parentCatName = "All Products";
        }

        let displayCats = availableCats.filter((cat)=>{return cat.parentCategoryId === current})





        return <div className="flex-column gap-med " style={{fontSize:"13px",borderRadius:"4px"}}>
        
                
              {  <div className="flex-row justify-between" style={{background:"#f7f7f7",padding:"8px"}}  >
                
                <button className="invisible-button"  onClick={()=>{setCurrentCat(parentId);}} >{parentCatName.length>0&&<LeftCaret/> }&nbsp;{parentCatName}</button>
               
                
                <button className="invisible-button" style={{color:(parentCatName!=""?"#333":"#777")}} onClick={()=>{setCurrentCat("")}} >Clear</button>
            </div>
        }
    
            <div className="flex-column gap-small" style={{borderRadius:"4px",padding:"8px 12px"}}>
        <div style={{fontWeight:"600",padding:" 0px 4px 4px 4px"}} >✓&nbsp;{ (currentCat? currentCat.name+" ("+currentCat.total+")":"All Products")}</div>

            {displayCats.map((cat,index)=>{
                return <button className="invisible-button gray-hover" key={cat.id} style={{cursor:"pointer",padding:"6px 8px 6px 20px",textAlign:"left"}} onClick={()=>{
                    
                    console.log("clicked, setting cat to ",cat.id);
                    
                    setCurrentCat(cat.id)}} >{cat.name+" ("+cat.total+")"} <RightCaret/></button>
            })}
            </div>
        </div>
        
    },[selectedCat,availableCats])

    const MapBrands =useCallback(()=> {

        return <div style={{fontSize:"14px"}}>
        {availableBrands.map((brand,index)=>{

            return <FilterCheckbox label={brand.name} 
            key={brand.id}
            onChange={(checked:boolean)=>{

                let newBrands:any[] = [...brands];
                if(checked){
                    newBrands.push(brand.id);
                }
                else{
                    newBrands = newBrands.filter((b)=>{return b!=brand.id});
                }

                setBrands(newBrands);

            }}
            isChecked={brands.includes(brand.id)}
            />

        })}
</div>
        

    },[brands,availableBrands])

    let brandName = brands.length==0?"All Brands": `${brands.length} Brand` + (brands.length>1?"s":"");

    let currentCat = availableCats.find((c)=>{return c.id === selectedCat});
    let catName = currentCat?currentCat.name:"All Products";

    return <div className="wb-input-group flex-column ">
       
        <FilterDropDown label="Filter Category" displayValue={catName} updated={selectedCat.length>0}  >

        <div style={{...bgStyle,padding:"0"}}>
            <MapCategories/>
            </div>
        </FilterDropDown>
        <br/>

        <FilterDropDown label="Filter Brands" displayValue={brandName} updated={brands.length>0}  >

        <div style={bgStyle}>
              <MapBrands/>
            </div>
        </FilterDropDown>
        <br/>

        <FilterDropDown label="Filter Search" displayValue={(search!=""?search:"None")} updated={search.length>0}  >

        <div style={bgStyle}>
            <div className="flex-row">
        <input type="text" className="w-full" defaultValue={search} 
            placeholder="Search Products"
            onKeyDown={(e)=>{if(e.key=="Enter"){setSearch(e.currentTarget.value)}}}
            
            onBlur={(e)=>{setSearch(e.target.value)}}/>
            </div>
            </div>
        </FilterDropDown>
       
        
    
    





  
 


    <div className="flex-row space-between" style={{marginTop:"20px"}}>
    <label className={(limit<50)?"updated":"not-updated"}>Limit Results</label>

    <SelectDropdown defaultValue={limit.toString()} options={limitOptions} onChange={(val:string)=>{setLimit(parseInt(val))}}/>
    </div>
    </div>



    // let inx = 0; // set default to the left most button incase we can't find its value
  
    // for(let i = 0;i<definition.options.length;i++){
    
    //   if(definition.options[i].value == val){
    //     inx = i;
    //     break;
    //   }
    // }
    
    // const [currentSlection,setSelection] = useState(inx);
    
    // const updateAttribute =(newValue:string)=>{
   
  
    //   updateFunc(definition.attKey,newValue,definition.targetType);
    //   let index = (newValue.length<=0)?0:definition.options.length;
    
    //     for (let i = 0; i < definition.options.length; i++) {
    //       if (definition.options[i].value == newValue) {
    //         index = i;
    //         break;
    //       }
    //     }
    
    //     setSelection(index);
    // }
    // return (
    //   <div className={"wb-input-group "+(extraClass??"")+" "+definition.attKey.toLowerCase() }>
    //     {label&&definition.label&&
    //     <label className={(val=="")?"not-updated":"updated"}>{label}</label>
    //   }
    //     <div className="wb-input-row">
    //       {definition.options.map((option, index) => {
    //         let className = index == currentSlection ? "selected" : "";
    
    //         return (
    //           <button
    //             className={className}
    //             key={index}
    //             style={(option.label=="Auto"||(option.label as string).length>2)?{fontSize:"13px"}:{}}
    //             onClick={() => {
    //               updateAttribute(option.value);
    //               //save update for special cases
    //               if(definition.attKey=="isLink"){
    //                 saveFunc();
    //               }
    //             }}
    //           >
    //             {option.label}
    //             {option.toolTip && <HoverToolTip text={option.toolTip} checkScroll={true}/>}
    //           </button>
    //         );
    //       })}
    //     </div>
    //   </div>
    // );

}

function FilterDropDown({label,displayValue,updated,startExpanded,children}:{label:string,displayValue:string,updated:boolean,startExpanded?:boolean,children:any}){

    const [isExpanded,setIsExpanded] = useState(startExpanded??false);

    return <><div className="flex-row justify-between w-full " style={{fontSize:"14px",cursor:"pointer"}}
             onClick={()=>{setIsExpanded(!isExpanded)}}
            > 
            <label className={updated?"updated":"not-updated"}>{label}</label>

            <div className="flex-row gap-med">
                <div className="ellipsis" style={{maxWidth:"100px"}} >{displayValue}</div>
                <div style={{fontSize:"10px",transform:(!isExpanded?"rotateZ(-90deg)":""),transition:".2s"}}>
                    <DownCaret/>
                </div>
            </div>
            </div>
            {
                isExpanded&&<>{children}</>
            }
            </>


}